import axios from "axios";

const BASE_URL = "https://s2a-academy.herokuapp.com/";
// const BASE_URL = "http://localhost:5000/";
const TOKEN = sessionStorage.getItem("accessToken");

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

export const userRequest = axios.create({
  baseURL: BASE_URL,
  headers: { token: `Bearer ${TOKEN}` },
});
